import produce from 'immer'
import { isEmpty } from 'lodash'
import { createChildListViewComponent } from 'factories/ChildListView'
import entityNames from 'options/entityNames'
import { t } from 'helpers/i18n'
import { isReadOnly } from 'helpers/formViews'
import { formatUserTime } from 'helpers/dateTime'
import Checkbox from 'elements/Checkbox'
import FormView from 'containers/Jobs/Checklist/FormView'

export default createChildListViewComponent({
  entityName: entityNames.jobs,
  childName: 'jobChecklist',
  createButtonTextId: 'addChecklistItem',
  createButtonLinkTarget: {
    formSize: 'xs',
    formComponent: FormView,
  },
  primaryLinkTarget: 'jobChecklistRecord',
  tableSummary: (self) => {
    if (self.props.isTemplate) {
      return ''
    }

    const { items = [] } = self.props
    const complete = items.filter((each) => each.complete).length
    const percentage = !isEmpty(items) ? Math.round((complete * 100) / items.length) : 0

    return `${complete} ${t('of')} ${items.length} ${t('itemsCompleted')} (${percentage}%)`
  },
  tableCellComponents: {
    complete: (self, item) => (
      <Checkbox
        key={Date.now()}
        checked={item.complete}
        disabled={isReadOnly(self) || self.props.isTemplate}
        onChange={async (e) => {
          try {
            await self.props.onChange(
              produce(self.props.items, (draftItems) => {
                const draftItem = draftItems.find((one) => one.id === item.id)

                draftItem.complete = e.target.checked
                draftItem.lastUser = draftItem.complete ? self.props.user.userName : null
                draftItem.lastUserDate = draftItem.complete ? new Date().toJSON() : null
              })
            )
          } catch (error) {
            console.warn(error)
          }
        }}
      />
    ),
    lastUserDate: (self, item) => formatUserTime(item.lastUserDate, item.lastUser),
  },
})()
